import styled from 'styled-components';

export const Text = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-height: 20px;
`;

export const rowCellClasses = {
  text: Text,
};
